var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 25C19.9614 25 25.334 19.6274 25.334 13C25.334 6.37258 19.9614 1 13.334 1C6.70657 1 1.33398 6.37258 1.33398 13C1.33398 19.6274 6.70657 25 13.334 25Z",
    stroke: "#ADBEEB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5798 10.5776C11.1416 10.5776 11.5971 10.1221 11.5971 9.56026C11.5971 8.99843 11.1416 8.54297 10.5798 8.54297C10.018 8.54297 9.5625 8.99843 9.5625 9.56026C9.5625 10.1221 10.018 10.5776 10.5798 10.5776Z",
    fill: "#1E3679"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4275 11.2568H9.73205C9.63846 11.2568 9.5625 11.3328 9.5625 11.4264V16.5128C9.5625 16.6064 9.63846 16.6824 9.73205 16.6824H11.4275C11.5211 16.6824 11.5971 16.6064 11.5971 16.5128V11.4264C11.5971 11.3328 11.5211 11.2568 11.4275 11.2568Z",
    fill: "#1E3679"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4792 10.9746C15.7545 10.7264 14.8481 10.9444 14.3045 11.3354C14.2859 11.2625 14.2194 11.2083 14.1404 11.2083H12.4449C12.3513 11.2083 12.2754 11.2842 12.2754 11.3778V16.4643C12.2754 16.5579 12.3513 16.6338 12.4449 16.6338H14.1404C14.234 16.6338 14.31 16.5579 14.31 16.4643V12.8088C14.584 12.5728 14.937 12.4975 15.2259 12.6203C15.506 12.7386 15.6664 13.0275 15.6664 13.4124V16.4643C15.6664 16.5579 15.7423 16.6338 15.8359 16.6338H17.5314C17.625 16.6338 17.7009 16.5579 17.7009 16.4643V13.0709C17.6816 11.6776 17.0261 11.1618 16.4792 10.9746Z",
    fill: "#1E3679"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinMedium);
export default __webpack_public_path__ + "static/media/linkedinMedium.140a5a1031c6e7ea73c485cb5d368ea3.svg";
export { ForwardRef as ReactComponent };